
var OurPayPayment = (function (PaymentProviderBase, CheckoutSettings) {

	var OurPayPayment = PaymentProviderBase.extend({

        type: 'mypay',
        paymentOption: CheckoutSettings.PaymentOption.OurPay,
		_supportedTypes: braintreeSupportedTypes.card.concat(braintreeSupportedTypes.paypal),
		_supportedOrderTypes: braintreeSupportedOrderTypes.card,
		_supportedProviderType: CheckoutSettings.PaymentOption.BrainTree,

        initialize: function (attrs, opts) {
            
			this._init = new $.Deferred();

			this.braintree = opts.Braintree;
            this.braintree.onSetupDone(this._init.resolve);
		},

        complete: function (method) {
            var transactionData = {
				paymentType: 'mypay',
                provider: 'braintree',
                selectedPaymentOption: this.paymentOption,
                paymentNonce: method.Nonce || '',
                paymentToken: method.Token || '',
                deviceData: this.braintree.kount.getDeviceData() || ''
            };

            return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true })
			    .fail(_.bind(this._fireError, this));
		},
		_fireError: function (err) {
			// TBD: PAPI must return message with Rejection Codes
			// TBD: no untrusted code

			if (!err.Message) {
				switch (err.Value.rejectionCode) {
					case CheckoutSettings.MyPayRejectionCodes.outOfRange:
						//err.Message = 'Only available for orders between £100 and £500';
						err.Message = kos.getPageTemplate('_OurPayRejectionOutOfRange');
						break;
					case CheckoutSettings.MyPayRejectionCodes.exceededDebtLimit:
						//err.Message = 'You can\'t pay with OurPay now because you exceed your credit limit. You could pay with OurPay after next payment on the earlier purchase.';
						err.Message = kos.getPageTemplate('_checkoutMyPayPayExceedLimit').format('OurPay');
						break;
					case CheckoutSettings.MyPayRejectionCodes.invalidPaymentMethod:
						//err.Message = 'we don\'t support your current payment method for it. If you choose another payment method you could use it.';
						err.Message = kos.getPageTemplate('_checkoutMyPayPayInvalidPaymentMethod').format('OurPay');
						break;
				}
			}

			this._checkoutStoreDispatcher.trigger('ourpay-error', err);
        }
	});

	return OurPayPayment;
})(PaymentProviderBase, CheckoutSettings);
